function getImage(sizes, windowWidth) {
  if (windowWidth < 5e2) return sizes.medium_large;
  if (windowWidth < 1e3) return sizes.medium_large;
  return sizes.large;
}

export default getImage;



// WEBPACK FOOTER //
// ./src/utils/getImage.js